import { AnalyticCategoryActions } from 'models';
import { ProductCodeType } from 'state/secondaryMarket/productSearch';

const toFileCodeKey = (code: string) => `FILE_CODE::${code}`;
const toIsinKey = (code: string) => `ISIN::${code}`;
const toCusipKey = (code: string) => `CUSIP::${code}`;
const toValorenKey = (code: string) => `VALOREN::${code}`;
const toWknKey = (code: string) => `WKN::${code}`;
const toEliotKey = (code: string) => `ELIOT:ID_WARRANT:${code}`;
const toXoneKey = (code: string) => {
  const subType = code.substring(0, 3);
  const xoneCode = code.replace(`${subType}-`, '');

  return `XONE:${subType}:${xoneCode}`;
};
const toEliotOtcKey = (code: string) => `ELIOT:ID_FO:${code}`;

type ProductCodeTypeConfig = {
  action: Extract<
    AnalyticCategoryActions['Secondary market batch'],
    | 'Product search by ELIOT OTC'
    | 'Product search by FILE_CODE'
    | 'Product search by CUSIP'
    | 'Product search by ELIOT'
    | 'Product search by XONE'
    | 'Product search by ISIN'
    | 'Product search by VALOREN'
    | 'Product search by WKN'
  >;
  cvtToKey: (val: string) => string;
};

export const configByCodeType: Record<ProductCodeType, ProductCodeTypeConfig> = {
  'ELIOT OTC': { action: 'Product search by ELIOT OTC', cvtToKey: toEliotOtcKey },
  'File Code': { action: 'Product search by FILE_CODE', cvtToKey: toFileCodeKey },
  CUSIP: { action: 'Product search by CUSIP', cvtToKey: toCusipKey },
  ELIOT: { action: 'Product search by ELIOT', cvtToKey: toEliotKey },
  XONE: { action: 'Product search by XONE', cvtToKey: toXoneKey },
  ISIN: { action: 'Product search by ISIN', cvtToKey: toIsinKey },
  VALOREN: { action: 'Product search by VALOREN', cvtToKey: toValorenKey },
  WKN: { action: 'Product search by WKN', cvtToKey: toWknKey },
} as const;
